const LK_Home =({color,width,height})=>{
    return(
        <svg fill={color} id="Layer_1"  data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 116.99 116.99">
            {/* <defs>
                <style>
                .cls-1 {
                    fill: #000000;
                    stroke-width: 0px;
                }
                </style>
            </defs> */}
            
            <path  d="M58.49,11.48l52.26,29.68h-11.1v64.99h-17.33v-51.99h-34.66v51.99h-20.22c-5.57,0-10.11-4.54-10.11-10.11v-54.88H6.23L58.49,11.48M58.49,6.5L0,39.72v5.78h13v50.55c0,7.98,6.47,14.44,14.44,14.44h24.55v-51.99h26v51.99h26V45.49h13v-5.78L58.49,6.5h0Z"/>
            </svg>
    );
};

export default LK_Home;
